<template>
  <div class="pop">
    <div class="modal">
      <div class="modalInner">
        <slot/>
        <div class="button" @click="nextToDo">
          {{ btnText }}
        </div>
      </div>
      <div class="close" @click="handleClose">
        <img :src="close" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import close from '@/assets/images/account/closeUpiPop.svg'

export default {
  name: 'UpiGiftReward',
  props: ['handleClose', 'btnText', 'nextToDo'],
  data () {
    return {
      close,
      currentIndex: 0
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 999;

  .modal {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 86.667vw;
    background: #737373;
    border-radius: 4.166vw;
    padding: 0.333vw;

    .modalInner {
      width: 100%;
      height: 100%;
      background: radial-gradient(55.26% 69.13% at 56.09% 47.9%, #151715 0%, #202020 100%);
      border-radius: 3.8vw;
      padding: 5vw 0 7.32vw 0;

      .button {
        background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
        width: 73.194vw;
        height: 9.536vw;
        line-height: 9.536vw;
        text-align: center;
        margin: 0 auto;
        color: #000000;
        font-size: 4.166vw;
        font-weight: 600;
        text-transform: capitalize;
        border-radius: 1.388vw;
      }
    }

    .close {
      position: absolute;
      bottom: -8vw;
      left: 50%;
      transform: translate(-50%);
      width: 3.8889vw;
      height: 3.8889vw;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UpiGiftReward/index.vue